<template>
   <div class="paginComponen">
    <el-pagination :class="{pagination: true, paginationActive:paddingActive}" v-model:page-size="pageSizeCompone" :page-sizes="[12]" :background="true"
    layout="total, prev, pager, next, sizes," :total="totalCompone" @size-change="handleSizeChange"
    @current-change="handleCurrentChange" />
   </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, reactive, toRefs, watch } from 'vue'

export default defineComponent({
    name: 'headPortrait',
    components: {
    },
    emits: ['changePage'],
    props: {
        pageSizeCompone: {
            type: Number,
            default: 12
        },
        totalCompone: {
            type: Number,
            default: 0
        },
        paddingActive: {
            type: Boolean,
            default: false
        }
    },
    setup(props: any, { emit }: any) {
        const state = reactive({
            handleSizeChange(val: number) {
                console.log(`${val} items per page`)
            },
            handleCurrentChange(val: number) {
                console.log(`current page: ${val}`)
                emit('changePage',val)
            },
        })

        onMounted(() => {

        })

        return {
            ...toRefs(state),
        }
    }
})

</script>

<style lang="scss" scoped>

.paginComponen{
    .pagination{
        margin-top: 10px;
        padding: 30px 0px 0px !important;
        position: relative;
        right: 20px;
        bottom: 10px;
    }
    .paginationActive{
        margin-top: 0px;
        padding-top: 0px !important;
        bottom: 20px;
    }
}

</style>